// extracted by mini-css-extract-plugin
module.exports = {"section":"_1SBzH","nextSectionOver":"_2GGyA","backgroundImage":"_3XYPl"};